export default "/fonts/vendor/remixicon/remixicon.svg?9cedd2150922ead848695530d71a212f";